/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total hours`)
};

const es_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de horas`)
};

const de_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Stunden`)
};

const nl_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal uren`)
};

const fr_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total d'heures`)
};

const it_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore totali`)
};

const pt_br2_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de horas`)
};

const pt_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de horas`)
};

const ja_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総時間`)
};

const zh_age_total_hours = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总小时数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_total_hours = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_total_hours(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_total_hours", locale)
	if (locale === "en") return en_age_total_hours(inputs)
	if (locale === "es") return es_age_total_hours(inputs)
	if (locale === "de") return de_age_total_hours(inputs)
	if (locale === "nl") return nl_age_total_hours(inputs)
	if (locale === "fr") return fr_age_total_hours(inputs)
	if (locale === "it") return it_age_total_hours(inputs)
	if (locale === "pt-BR") return pt_br2_age_total_hours(inputs)
	if (locale === "pt") return pt_age_total_hours(inputs)
	if (locale === "ja") return ja_age_total_hours(inputs)
	return zh_age_total_hours(inputs)
};